import { LiveList } from "@liveblocks/client"
import { ErrorBoundary, TagField } from "@prismicio/editor-ui"
import { Suspense, useState } from "react"

import { useRepositoryTags } from "../app/services/repository"
import { useCollaborationStorage } from "./collaboration/CollaborationRoom"
import { useDocument, useDocumentReadOnly } from "./DocumentProvider"

export function DocumentTags() {
  const { draft, status } = useDocument()
  const readOnly = useDocumentReadOnly()

  const [open, setOpen] = useState(false)

  const collaborationStorage = useCollaborationStorage({ status })

  function onSelectedValuesChange(newValue: Set<string>) {
    collaborationStorage?.updateAndMaybeRedirect({
      tags: new LiveList(Array.from(newValue)),
    })
    draft.updateTags(newValue)
  }

  return (
    <ErrorBoundary
      renderError={() => (
        <TagField
          selectedValues={draft.documentTags}
          onSelectedValuesChange={onSelectedValuesChange}
          error
          open={open}
          setOpen={setOpen}
          disabled={readOnly}
        />
      )}
    >
      <Suspense
        fallback={
          <TagField
            selectedValues={draft.documentTags}
            onSelectedValuesChange={onSelectedValuesChange}
            loading
            open={open}
            setOpen={setOpen}
            disabled={readOnly}
          />
        }
      >
        <RepositoryPopulatedTagField
          open={open}
          setOpen={setOpen}
          selectedValues={draft.documentTags}
          onSelectedValuesChange={onSelectedValuesChange}
          disabled={readOnly}
        />
      </Suspense>
    </ErrorBoundary>
  )
}

interface RepositoryPopulatedTagFieldProps {
  open: boolean
  setOpen: (open: boolean) => void
  selectedValues: Set<string>
  onSelectedValuesChange: (selectedValues: Set<string>) => void
  disabled?: boolean
}

function RepositoryPopulatedTagField(props: RepositoryPopulatedTagFieldProps) {
  const repositoryTags = new Set(useRepositoryTags().results)

  return <TagField {...props} values={repositoryTags} />
}
